import { useStore } from 'vuex'
import { useAdmin } from './useAdmin'

/**
 * Returns `can(permKey)` — checks whether the current logged-in user
 * has the given permission according to their profile assignment.
 *
 * The function reads reactive state (store getters + useAdmin state),
 * so calling it inside a template or computed will track dependencies
 * and re-evaluate when profiles/user change.
 */
export function usePermission() {
  const store = useStore()
  const { hasPermission, getProfileTeamIds } = useAdmin()

  function can(permKey: string): boolean {
    const user  = store.getters.authUser
    if (!user?.id) return false
    const teamIds: number[] = store.getters.userTeamIds ?? []
    return hasPermission(user.id, teamIds, permKey)
  }

  /**
   * IDs de times que o usuário atual pode escolher pra reatribuir — sempre
   * null (sem restrição) de propósito, ver getProfileTeamIds em useAdmin.ts.
   */
  function allowedTeamIds(): number[] | null {
    return getProfileTeamIds()
  }

  return { can, allowedTeamIds }
}
